import {
    FETCH_STORYBOARD_IMPROVEMENT_FAILED,
    FETCH_STORYBOARD_IMPROVEMENT_START,
    FETCH_STORYBOARD_IMPROVEMENT_SUCCESS
} from '../../constants';
import { TOPIC_WORDCLOUD_URL } from '../../../../config/constants';
import { ApiBase } from '../../../utils/apiBase';
import { withType } from '../../../utils/actionOperations';
import { getProjectIdAndOrgId } from '../../../utils/apiUtils';

export const fetchStoryboardImprovement = (payload, cb) => {
    const apiBaseInstance = new ApiBase();
    return dispatch => {
        dispatch(withType(FETCH_STORYBOARD_IMPROVEMENT_START, {}));
        apiBaseInstance.instance
            .post(TOPIC_WORDCLOUD_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then(response => {
                dispatch(withType(FETCH_STORYBOARD_IMPROVEMENT_SUCCESS, {
                    data: response.data,
                    message: response.message,
                }));
                setTimeout(() => {
                    cb && cb();
                }, 0)
            })
            .catch(err => {
                dispatch(withType(FETCH_STORYBOARD_IMPROVEMENT_FAILED, {
                    error: err
                }));
            });
    };
};
